import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  ADD_ACTIVITY,
  getApiBaseUrl,
  LOGIN,
  GET_ROLES,
} from "../../Config/Config";
import { Spin } from "antd";

const NewUser = () => {
  const [userData, setUserData] = useState({
    name: "",
    role: "",
    UserID: "",
    userType: "",
  });
  const [loading, setLoading] = useState(false);
  const [askPassword, setAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [error, setError] = useState("");
  // New state for roles
  const [roles, setRoles] = useState([]);
  console.log(roles, "rolessssssssss");
  const selectedRole = roles.find((r) => r.id === Number(userData.role));
  console.log(selectedRole, "selectedRole");
  // Fetch roles on component mount
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await fetch(`${getApiBaseUrl()}${GET_ROLES}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const result = await res.json();
        if (result.Status && result.ResultData) {
          setRoles(result.ResultData);
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };
    fetchRoles();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    // Always required fields check first:

    const payload = {
      name: userData.name,
      role: parseInt(userData.role),
      username: userData.UserID,
      usertype: userData.userType,
    };

    setLoading(true);

    let registerSucceeded = false;
    let tempPassword = null;
    let registerMessage = "User registered successfully!";

    try {
      const res = await fetch(`${getApiBaseUrl()}/registerPh2`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (result.status) {
        registerSucceeded = true;
        tempPassword = result.ResultData?.TemporaryPassword;
        registerMessage = result.Message || registerMessage;
      } else {
        registerMessage = result.Message || "Something went wrong.";
      }
    } catch (error) {
      registerMessage = "Unable to connect to the server.";
    } finally {
      setLoading(false);

      if (registerSucceeded) {
        Swal.fire({
          icon: "success",
          title: "Success",
          html: `
          <p>${registerMessage}</p>
          ${
            tempPassword
              ? `
                <p>
                  <strong>Temporary Password:</strong> 
                  <span id="tempPassword">${tempPassword}</span>
                  <button id="copyBtn" style="margin-left:8px;padding:2px 6px;font-size:0.8rem;border-radius:4px;border:1px solid #ccc;cursor:pointer;">Copy</button>
                </p>
              `
              : ""
          }
        `,
          confirmButtonText: "OK",
          didOpen: () => {
            const copyBtn = Swal.getPopup().querySelector("#copyBtn");
            const passwordSpan = Swal.getPopup().querySelector("#tempPassword");

            if (copyBtn && passwordSpan) {
              copyBtn.addEventListener("click", () => {
                navigator.clipboard
                  .writeText(passwordSpan.textContent)
                  .then(() => {
                    copyBtn.textContent = "Copied!";
                    setTimeout(() => (copyBtn.textContent = "Copy"), 1500);
                  })
                  .catch(() => {
                    copyBtn.textContent = "Failed!";
                  });
              });
            }
          },
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: registerMessage,
        });
      }

      try {
        const user = JSON.parse(sessionStorage.getItem("user"));
        const userId = user?.UserID || 0;

        const activityPayload = {
          ActivityType: 6,
          PerformedBy: userId,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: registerSucceeded
            ? `User registration successful for ${userData.UserID}`
            : `User registration failed for ${userData.UserID}`,
          Location: "register",
          IsSucces: registerSucceeded ? 1 : 0,
        };

        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(activityPayload),
        });
      } catch (error) {
        console.error("Error calling /addActivity:", error);
      }
    }
  };

  const clearUserData = () => {
    setUserData({ name: "", role: "", UserID: "", userType: "" });
    setAskPassword(false);
    setPassword("");
    setError("");
  };

  useEffect(() => {
    const offcanvas = document.getElementById("offcanvasAddUser");
    if (offcanvas) {
      const handleClose = () => {
        clearUserData();
      };
      offcanvas.addEventListener("hidden.bs.offcanvas", handleClose);
      return () => {
        offcanvas.removeEventListener("hidden.bs.offcanvas", handleClose);
      };
    }
  }, []);

  const handleSaveClick = (e) => {
    e.preventDefault();
    if (!userData.name || !userData.role || !userData.UserID) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please fill in required fields: Username, Name and Role.",
      });
      return;
    }
    console.log(userData.userType, "userData.userType");

    // If role has usertype = true then userType must also be required
    if (selectedRole?.UserType) {
      if (!userData.userType) {
        Swal.fire({
          icon: "warning",
          title: "Validation Error",
          text: "Please select User Type (Process / Non-Process) for Supervisor / Operator users.",
        });
        return;
      }
    }

    setAskPassword(true);
  };

  const handleAuth = async () => {
    setAuthLoading(true);
    setError("");
    const user = JSON.parse(sessionStorage.getItem("user"));

    try {
      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        setAskPassword(false);
        setPassword("");
        await handleSubmit();
      } else {
        setError("Invalid credentials");
      }
    } catch (err) {
      setError("Invalid Password. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasAddUser {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasAddUser {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasAddUser {
            width: 35% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasAddUser {
            width: 20% !important;
          }
        }
        `}
      </style>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      {authLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasAddUser"
        aria-labelledby="offcanvasAddUserLabel"
      >
        <form>
          <div className="offcanvas-header d-flex justify-content-between align-items-center w-100">
            <h5 id="offcanvasAddUserLabel">Add New User</h5>
            <div className="d-flex align-items-center ms-auto">
              <button
                type="submit"
                className={`btn btn-sm btn-outline-success me-2 ${
                  askPassword ? "d-none" : ""
                }`}
                title="Save"
                onClick={handleSaveClick}
                disabled={loading}
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <hr className="m-0" />
          <div className="offcanvas-body">
            <div className="row">
              <div className="col-6 mb-3">
                <label className="form-label">User ID</label>
                <span className="text-danger ms-1">*</span>
                <input
                  min={1}
                  max={99999}
                  type="number"
                  name="UserID"
                  className="form-control"
                  placeholder="Enter User ID"
                  value={userData.UserID}
                  onChange={handleChange}
                  onWheel={(e) => e.target.blur()}
                  required
                  disabled={loading || askPassword}
                />
              </div>
              <div className="col-6 mb-3">
                <label className="form-label">Name</label>
                <span className="text-danger ms-1">*</span>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder="Enter Name"
                  value={userData.name}
                  onChange={handleChange}
                  required
                  disabled={loading || askPassword}
                />
              </div>
              <div className="col-6 mb-3">
                <label className="form-label">Role</label>
                <span className="text-danger ms-1">*</span>
                <select
                  name="role"
                  className="form-select"
                  value={userData.role}
                  onChange={handleChange}
                  required
                  disabled={loading || askPassword}
                >
                  <option value="">Select Role</option>
                  {roles.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </select>
              </div>
              {selectedRole?.UserType && (
                <div className="col-6 mb-3">
                  <label className="form-label">Attribute</label>
                  <span className="text-danger ms-1">*</span>
                  <select
                    name="userType"
                    className="form-select"
                    value={userData.userType}
                    onChange={handleChange}
                    required
                    disabled={loading || askPassword}
                  >
                    <option value="">Select Attribute</option>
                    <option value="1">Process</option>
                    <option value="2">Non-Process</option>
                  </select>
                </div>
              )}
            </div>
            {askPassword && (
              <div className="mt-2">
                <div className="mb-3 w-lg-75 m-auto">
                  <label className="form-label">
                    Confirm Password <span className="text-danger"> *</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="pass-input form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                      placeholder="Enter Password"
                    />
                    <span
                      className={`ti toggle-password ${
                        showPassword ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={() => setShowPassword(!showPassword)}
                    ></span>
                  </div>
                </div>

                {error && <div className="text-danger small mb-2">{error}</div>}

                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={handleAuth}
                  disabled={authLoading || !password}
                >
                  {authLoading ? "Verifying..." : "Confirm"}
                </button>
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => {
                    setAskPassword(false);
                    setPassword("");
                    setError("");
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewUser;
